import {
  API_ENDPOINT,
  useClientApiV1AuthChangePhoneNumberCreateMutation,
} from '../../resources/@types/accountSchema';

export function useClientAuthChangePhoneNumberCreateMutation(
  options?: Parameters<typeof useClientApiV1AuthChangePhoneNumberCreateMutation>[0]['options'],
) {
  return useClientApiV1AuthChangePhoneNumberCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_AUTH_CHANGE_PHONE_NUMBER,
    options,
  });
}
